import { useCallback, useMemo, useRef, useState } from 'react';

import Modal from '../../common/Modal/Modal';

interface IProps {
  children: JSX.Element;
  side?: 'center' | 'right' | 'bottom';
  size?: 'small';
  keepMounted?: boolean;
  preventNavigate?: boolean;
  keepOpen?: boolean;
}

interface IModalOptions {
  closeCallback?: () => unknown;
}

const useModal = (options?: IModalOptions) => {
  const [isOpen, setIsOpen] = useState(false);
  const openBtnRef = useRef<{ element: HTMLButtonElement | null }>({ element: null });
  const closeCallback = useRef({
    f: () => {},
  });

  const open = useCallback((ref?: HTMLButtonElement) => {
    openBtnRef.current.element = ref || null;
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    if (options?.closeCallback) options.closeCallback();
  }, [options]);

  const modal = useCallback(
    ({ children, side, keepMounted, preventNavigate, size, keepOpen }: IProps) => (
      <Modal
        isOpen={keepOpen || isOpen}
        close={close}
        side={side}
        size={size}
        openBtn={openBtnRef.current.element}
        closeCallback={closeCallback}
        keepMounted={keepMounted}
        preventNavigate={preventNavigate}
        keepOpen={keepOpen}
      >
        {children}
      </Modal>
    ),

    [close, isOpen],
  );

  const value = useMemo(
    () => ({ isOpen, open, close, modal, openBtnRef, closeCallback }),
    [close, isOpen, modal, open],
  );

  return value;
};

export default useModal;
